import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import queryString from 'query-string'
import BasePage from '../BasePage';
import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import { ToastTypes } from "../../modals/FuseToast";
import { fetchGenericData } from '../../../../webservices/generic/genericDataWs';
import { showDataFetchError } from '../../../../actions/generic/fuseAlerts';
import { fetchUserProfile, updateUserProfile } from '../../../../webservices/profile/profileWs';
import { ContinuousColorLegend } from 'react-vis';
import FuseInputBox from '../../inputFields/FuseInputBox';

class ProfilePage extends React.Component{

    constructor(props) {
        super(props);
        this.state = {  
			    data: null,
          origionalData: null,
          isDirty: false
        };
    } 
    
    componentDidMount(){
      this.loadUserProfileData();
    } 

    render(){
            if(this.state.data == null)
              return <p>loading...</p>;
            return (
            <BasePage>
            <>
              <Form>
                <Form.Group className="mb-3" controlId="formBasicName">
                  <Form.Label>Name:</Form.Label>
                  <FuseInputBox type="text" value={this.state.data.name} placeholder="Name"  onChange={(val)=>{
                    this.state.data.name = val;
                    if( this.state.origionalData.name !== val){
                      this.state.isDirty = true;
                    }
                  }} editable/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicEmaiSurnamel">
                  <Form.Label>Surname:</Form.Label>
                  <FuseInputBox type="text"  value={this.state.data.surname} placeholder="Surname"  onChange={(val)=>{
                     this.state.data.surname = val;
                     if( this.state.origionalData.surname !== val){
                       this.state.isDirty = true;
                     }
                  }} editable/>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email Address:</Form.Label>
                  <FuseInputBox type="email"  value={this.state.data.emailAddress} placeholder="Email"  on onChange={(val)=>{
                    this.state.data.emailAddress = val;
                    if( this.state.origionalData.emailAddress !== val){
                      this.state.isDirty = true;
                    }
                  }} editable/>
                </Form.Group>
              
                <Form.Group className="mb-3" controlId="formBasicLastLogin">
                  <Form.Label>Last login</Form.Label>
                  <FuseInputBox type="DateTime"  value={this.state.data.lastLoginTime}  placeholder="Last login" onChange={(val)=>{
                  }} />
                </Form.Group>

                <Card body>
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <FuseInputBox type="password" value={this.state.data.password1} placeholder="Password" onChange={(val)=>{
                      this.state.data.password1 = val;
                      this.state.isDirty = true;
                    }} editable/>
                    
                    <br/>
                    <Form.Label>Confirm Password</Form.Label>
                    <FuseInputBox type="password" value={this.state.data.password2} placeholder="Confirm Password" onChange={(val)=>{
                      this.state.data.password2 = val;
                      this.state.isDirty = true;
                    }} editable/>
                  </Form.Group>
                </Card>
                <br/>
                <Button variant="primary" type="submit" onClick={this.onUpdateProfileInfo}>
                  Update
                </Button>
                <br/>
                <br/>
              </Form>
              <br/>
           </>
           <br/>
           <br/>
          </BasePage>);
    }
	  
    componentDidUpdate(prevProps) {
    }
    
        
    loadUserProfileData = () => {
      fetchUserProfile()
        .then((response) => {
          if (!_.isEmpty(response.error)) {
            console.log('Error fetching profile data:');
            console.log(JSON.stringify(response.error));
            this.props.showDataFetchError(response.error.message);
            this.props.addToast(ToastTypes.ERROR, "Error fetching profile information");
          }
          else if (response.data.success === true) {
            let data = response.data.result;
            this.setState({data: data, origionalData: {...data}});//copy
          }
          else {
            console.log('Error fetching profile data:');
            console.log(JSON.stringify(response.data));
            this.props.showDataFetchError();
            this.props.addToast(ToastTypes.ERROR, "Error fetching profile information");
          }
        })
        .catch(function (error) {
          console.log('exception:' + error);
        // this.props.showDataFetchError(error.message);
        })
    }

    onUpdateProfileInfo = () => {
      if(this.state.isDirty === true){
        this.updateProfileInformation(this.state.data);
      }  
    }

    updateProfileInformation(update){
      updateUserProfile(update)
        .then((response) => {
          if (!_.isEmpty(response.error)) {
            console.log('Error updating profile data:');
            console.log(JSON.stringify(response.error));
            this.props.showDataFetchError(response.error.message);
          }
          else if (response.data.success === true) {
            this.loadUserProfileData();
          }
          else {
            console.log('Error updating profile data:');
            console.log(JSON.stringify(response.data));
            this.props.showDataFetchError();
          }
        })
        .catch(function (error) {
          console.log('exception:' + error);
        // this.props.showDataFetchError(error.message);
      })
    }
  
  }

  const mapStateToProps = (state, ownProps) => {
    const values = queryString.parse(ownProps.location.search)
      return{
          fetchingData: state.fetchingData === true,
          auth: state.auth,
          screenId: values.screenId,
          parent: values.parent,
          screenInfo: state.screenInfo
      };
  }
  
  export default connect(
      mapStateToProps, 
      (dispatch, ownProps) => ({
		showDataFetchError: (exception) => dispatch(showDataFetchError(exception)),
        })
      )(ProfilePage);